export const getTickOffset = (
  axis: Highcharts.Axis,
  plotWidth: number,
  isSplit: boolean,
  axisEndOffset: {
    min: number;
    max: number;
  } = {
    min: 0,
    max: 0,
  }
) => {
  const dataMin = (axis.min ?? 0) + axisEndOffset.min;
  const dataMax = (axis.max ?? 0) - axisEndOffset.max;
  const dataRange = dataMax - dataMin;
  const tickInterval = axis.options.tickInterval ?? 1;
  const numIntervals = Math.ceil(dataRange / tickInterval) + (isSplit ? 1 : 0);
  return Math.floor(plotWidth / numIntervals / (isSplit ? 2 : 4));
};
